import {
  Box,
  Column,
  Columns,
  Divider,
  Hidden,
  IconTick,
  ContentBlock,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { encodeSvg } from 'src/shared/helpers';

import { RECRUITER_NETWORK_URL } from '../../../../../../shared/links';
import CTAButtonNoLinks from '../../../../branding/App/components/CTAButtonNoLinks';

import SeekLogo from './images/SeekLogo.svg';

import * as styles from './RecruiterNetwork.css';

const RecruiterNetwork = () => (
  <ContentBlock width="medium">
    <Box
      borderRadius="large"
      boxShadow="borderNeutralLight"
      padding="medium"
      width="full"
    >
      <Stack space="large">
        <Columns
          collapseBelow="desktop"
          space={{ desktop: 'xxlarge', mobile: 'large' }}
          alignY="center"
        >
          <Column>
            <Stack space="xsmall" align={{ desktop: 'left', mobile: 'center' }}>
              <Box
                className={styles.image}
                style={{
                  backgroundImage: encodeSvg(SeekLogo),
                  backgroundSize: 'contain',
                }}
              />

              <Text
                align={{ desktop: 'left', mobile: 'center' }}
                size="large"
                tone="secondary"
              >
                Connecting businesses with experienced recruiters who specialise
                in filling roles fast
              </Text>
            </Stack>
          </Column>
          <Column width="content">
            <Stack space="none" align="center">
              <CTAButtonNoLinks
                text={{
                  loggedIn: 'Go to SEEK Recruiter Network',
                  loggedOut: 'Go to SEEK Recruiter Network',
                }}
                href={{
                  loggedIn: RECRUITER_NETWORK_URL,
                  loggedOut: RECRUITER_NETWORK_URL,
                }}
                tracking={{
                  loggedIn: TRACKING_CODES.recruiter_network_link_clicked,
                  loggedOut: TRACKING_CODES.sign_in_link_clicked,
                }}
                variant="ghost"
                tone="formAccent"
              />
            </Stack>
          </Column>
        </Columns>
        <Hidden below="desktop">
          <Divider />
        </Hidden>
        <Stack space="large">
          <Stack space="large" align="left">
            <Box paddingX="large">
              <Columns space="large" collapseBelow="desktop">
                <Column width="1/3">
                  <Columns space="xsmall">
                    <Column width="content">
                      <IconTick tone="formAccent" />
                    </Column>
                    <Column>
                      <Box style={{ marginTop: '6px' }}>
                        <Stack space="gutter">
                          <Text size="large">
                            <div className={`${styles.recruiterColHeading}`}>
                              No success, no fee
                            </div>
                          </Text>
                          <Text>
                            Pay nothing until you find the right person. Our 90
                            day* money-back gurantee helps make sure you find
                            the right fit
                          </Text>
                        </Stack>
                      </Box>
                    </Column>
                  </Columns>
                </Column>
                <Column width="1/3">
                  <Columns space="xsmall">
                    <Column width="content">
                      <IconTick tone="formAccent" />
                    </Column>
                    <Column>
                      <Box style={{ marginTop: '6px' }}>
                        <Stack space="gutter">
                          <Text size="large">
                            <div className={`${styles.recruiterColHeading}`}>
                              Transparent, no upfront fees
                            </div>
                          </Text>

                          <Text>
                            SEEK sets simple terms so you know what you&apos;re
                            getting and have peace of mind throughout the entire
                            process
                          </Text>
                        </Stack>
                      </Box>
                    </Column>
                  </Columns>
                </Column>
                <Column width="1/3">
                  <Columns space="xsmall">
                    <Column width="content">
                      <IconTick tone="formAccent" />
                    </Column>
                    <Column>
                      <Box style={{ marginTop: '6px' }}>
                        <Stack space="gutter">
                          <Text size="large">
                            <div className={`${styles.recruiterColHeading}`}>
                              Experienced, highly-rated recruiters
                            </div>
                          </Text>
                          <Text>
                            Work with recruiters with transparent ratings and
                            reviews
                          </Text>
                        </Stack>
                      </Box>
                    </Column>
                  </Columns>
                </Column>
              </Columns>
            </Box>
          </Stack>
          <Text align={{ desktop: 'left', mobile: 'left' }} size="standard">
            *Subject to{' '}
            <TextLink
              tracking="recruiter-network-terms"
              href="https://talent.seek.com.au/recruiter-network/terms"
            >
              SEEK Recruiter Network Terms of Use
            </TextLink>
          </Text>
        </Stack>
      </Stack>
    </Box>
  </ContentBlock>
);

export default RecruiterNetwork;
